import { Box, Button, Typography } from '@mui/material';

const VariantHeader = ({ productVariant, handleSaveChanges, onClose }) => (
  <Box
    sx={{
      m: 2,
      backgroundColor: '#F6F6F6',
      justifyContent: 'space-between',
      py: 1,
      display: 'flex',
      alignItems: 'center',
      p: {
        sm: '10px',
        md: '40px 24px',
      },
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      border: '1.2px solid #F6F6F6',
      borderRadius: '4px',
      boxShadow: '0 2px 8px 0 #00000026, 0 0 0 1px #F6F6F6',
    }}
  >
    {/* Left Section: Image + Product Info */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
      }}
    >
      {/* Image */}
      <Box
        component="img"
        src={productVariant?.product?.image}
        alt={productVariant?.product?.name}
        sx={{
          width: 60,
          height: 60,
          borderRadius: 1,
          border: '1px solid #ccc',
        }}
      />

      {/* Product Info */}
      <Box>
        <Typography
          sx={{
            textAlign: {
              xs: 'center',
              md: 'left',
            },
          }}
          variant="h6"
          fontWeight="bold"
          whiteSpace="pre-line"
        >
          {productVariant?.product?.name}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: {
              xs: 1,
              md: 3,
            },
            mt: 0.5,
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            alignItems: {
              xs: 'center',
              sm: 'baseline',
            },
          }}
        >
          <Typography variant="body2" color="text.secondary">
            SKU: {productVariant?.product?.sku}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            MPN: {productVariant?.product?.mpn}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Color: {productVariant?.product?.color}
          </Typography>
        </Box>
      </Box>
    </Box>

    {/* Right Section: Buttons */}
    <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
      <Button
        variant="contained"
        sx={{
          bgcolor: 'success.dark',
          '&:hover': { bgcolor: 'success.main' },
          color: 'white',
          mr: 2,
          whiteSpace: 'nowrap',
        }}
        onClick={handleSaveChanges}
      >
        SAVE CHANGES
      </Button>
      <Button onClick={onClose} color="inherit">
        CANCEL
      </Button>
    </Box>
  </Box>
);

export default VariantHeader;
